import { useEffect, useState, useCallback } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import MarqueeSection from "@/components/MarqueeSection";
import ManifestoSection from "@/components/ManifestoSection";
import GallerySection from "@/components/GallerySection";
import ServiceAreaSection from "@/components/ServiceAreaSection";
import ServicesGrid from "@/components/ServicesGrid";
import InteractiveEstimator from "@/components/InteractiveEstimator";
import BookingContactSection from "@/components/BookingContactSection";
import Footer from "@/components/Footer";
import AdminPage from "@/pages/AdminPage";

const LandingPage = () => {
  const [estimate, setEstimate] = useState({});
  const [prefill, setPrefill] = useState(null);

  const addToEstimate = useCallback((item) => {
    setEstimate((prev) => ({
      ...prev,
      [item.name]: { ...item, qty: (prev[item.name]?.qty || 0) + 1 },
    }));
  }, []);

  const setQty = useCallback((name, qty) => {
    setEstimate((prev) => {
      const next = { ...prev };
      if (qty <= 0) delete next[name];
      else next[name] = { ...next[name], qty };
      return next;
    });
  }, []);

  const items = Object.values(estimate);

  return (
    <div className="bg-carbon text-slate-100 min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <MarqueeSection />
        <ServicesGrid onAdd={addToEstimate} />
        <InteractiveEstimator
          items={items}
          onSetQty={setQty}
          onClear={() => setEstimate({})}
          onBook={(summary) => setPrefill({ service: "Custom Estimate (multi-service)", notes: summary })}
        />
        <ManifestoSection />
        <GallerySection />
        <ServiceAreaSection />
        <BookingContactSection prefill={prefill} onPrefillConsumed={() => setPrefill(null)} />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}

export default App;
